module.exports = __webpack_public_path__ + "media/newlogin.98586705.mp4";